<template>
  <section class="fleet-list-data" :class="{ 'is-light': main.editorTheme === 'light' }" aria-label="列表数据配置">
    <el-radio-group v-model="dataSource" aria-label="列表数据来源" size="mini"><el-radio-button label="platform">平台数据</el-radio-button><el-radio-button label="static">静态数据</el-radio-button></el-radio-group>
    <template v-if="dataSource === 'static'">
    <h2 class="editor-panel-heading">静态示例数据</h2>
    <p>用于验证列表样式和滚动，不发送 HTTP 或 WS 请求。点击“应用数据”更新当前组件，保存大屏后才写入项目。</p>
    <p>{{ kind === 'product' ? '必填：id、name。可选：deviceCount、onlineCount、alarmCount（非负整数）。' : '必填：id、name、productId。可选：productName、state、lastSeen。state：online / offline / notActive / unknown。' }}</p>
    <label for="fleet-data-json">示例数据（JSON 数组）</label>
    <el-input id="fleet-data-json" type="textarea" label="示例数据JSON" :rows="14" v-model="draft" :aria-invalid="error ? 'true' : 'false'" aria-describedby="fleet-data-status" @input="error = ''; applied = false"></el-input>
    <p v-if="error" id="fleet-data-status" role="alert">{{ error }}</p>
    <p v-else id="fleet-data-status" role="status">{{ applied ? '已应用到当前组件，记得保存大屏' : dirty ? '编辑尚未应用到画布' : '当前数据与画布一致' }}</p>
    <div class="fleet-list-data__actions"><el-button size="mini" type="primary" :disabled="!dirty" @click="apply">应用数据</el-button><el-button size="mini" :disabled="!dirty" @click="reset">放弃未应用修改</el-button></div>
    </template>
  </section>
</template>
<script>
import { validateListData, usesPlatformData } from './model'
export default {
  inject: ['main'],
  data: () => ({ draft: '', error: '', applied: false }),
  computed: {
    dataSource: {
      get () { return usesPlatformData(this.main.activeOption) ? 'platform' : 'static' },
      set (value) { this.$set(this.main.activeOption, 'dataSource', value) }
    },
    kind () { return this.main.activeComponent.prop === 'productList' ? 'product' : 'device' },
    current () { return JSON.stringify(this.main.activeObj.data, null, 2) || '[]' },
    dirty () { return this.draft !== this.current }
  },
  watch: { current (value, before) { if (this.draft === before) this.draft = value } },
  created () { this.reset() },
  methods: {
    reset () { this.draft = this.current; this.error = ''; this.applied = false },
    apply () {
      let value
      try { value = JSON.parse(this.draft) } catch (e) { this.error = 'JSON 格式错误，请检查引号、逗号和括号'; return }
      this.error = validateListData(this.kind, value)
      if (this.error) return
      this.$set(this.main.activeObj, 'data', value)
      this.draft = JSON.stringify(value, null, 2)
      this.applied = true
    }
  }
}
</script>
<style scoped>
.fleet-list-data { font-size: 12px; line-height: 1.7; overflow-wrap: anywhere; }
.fleet-list-data label { display: block; margin: 12px 0 6px; }
.fleet-list-data__actions { display: flex; flex-wrap: wrap; gap: 8px; }
.fleet-list-data__actions .el-button { margin-left: 0; }
.fleet-list-data [role="alert"] { color: #ffb76b; }
.fleet-list-data.is-light [role="alert"] { color: #b23a00; }
</style>
